import SVG from 'react-inlinesvg';
import cx from 'classnames';
import { useToggle } from 'customHooks/useToggle';
import ShowMoreMenu from 'lib/ShowMoreMenu/ShowMoreMenu';
import eraseSvg from 'assets/icons/erase.svg';
import eyeSvg from 'assets/icons/eye_empty.svg';
import arrowsOutSvg from 'assets/icons/arrows_out.svg';
import SectionDivider from 'components/pages/Planner/SectionDivider';

interface ObjectiveSelectionMenuProps {
  isDisabled: boolean;
  isClearAllDisabled?: boolean;
  isCollapseDisabled?: boolean;
  isExplodeDisabled?: boolean;
  isCollapsed?: boolean;
  onClear: () => void;
  onExplode: () => void;
  onCollapseOrExpand: () => void;
}

export const ObjectiveSelectionMenu: React.FC<ObjectiveSelectionMenuProps> = ({
  isDisabled,
  isClearAllDisabled = false,
  isCollapseDisabled = false,
  isExplodeDisabled = false,
  isCollapsed = false,
  onClear,
  onExplode,
  onCollapseOrExpand,
}) => {
  const { isOpen, toggle, close } = useToggle(false);

  const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, actionCallback: VoidFunction): void => {
    e.stopPropagation();
    close();
    actionCallback();
  };

  return (
    <ShowMoreMenu isOpen={isOpen} onToggle={toggle} isDisabled={isDisabled} svgClassName="cursor-pointer">
      <button
        className={cx(
          'py-2 px-2 w-full flex justify-start items-center text-essential-secondary body-base space-x-2 enabled:hover:bg-primary-50',
          {
            'cursor-not-allowed opacity-50': isCollapseDisabled,
          },
        )}
        type="button"
        onClick={(e) => onClick(e, onCollapseOrExpand)}
        disabled={isCollapseDisabled}
      >
        <p className="w-10/12 text-left body-base truncate whitespace-nowrap overflow-hidden">
          {isCollapsed ? 'Show more' : 'Show less'}
        </p>
        <SVG src={eyeSvg} className="w-4 h-4" />
      </button>
      <SectionDivider />
      <button
        className={cx(
          'py-2 px-2 w-full flex justify-start items-center body-base space-x-2 enabled:hover:bg-primary-50',
          {
            'cursor-not-allowed opacity-50 text-essential-secondary': isExplodeDisabled,
          },
        )}
        type="button"
        disabled={isExplodeDisabled}
        onClick={(e) => onClick(e, onExplode)}
      >
        <p className="w-10/12 text-left body-base truncate whitespace-nowrap overflow-hidden">Explode</p>
        <SVG src={arrowsOutSvg} className="w-4 h-4" />
      </button>
      <SectionDivider />
      <button
        className={cx(
          'py-2 px-2 w-full flex justify-start items-center body-base space-x-2 enabled:hover:bg-primary-50',
          {
            'text-red-900': !isClearAllDisabled,
            'cursor-not-allowed opacity-50 text-essential-secondary': isClearAllDisabled,
          },
        )}
        type="button"
        disabled={isClearAllDisabled}
        onClick={(e) => onClick(e, onClear)}
      >
        <p className="w-10/12 text-left body-base truncate whitespace-nowrap overflow-hidden">Clear</p>
        <SVG src={eraseSvg} className="w-4 h-4" />
      </button>
    </ShowMoreMenu>
  );
};
